export default __webpack_public_path__ + "static/media/footerLogo.ef0049fa.svg";